// Generated by CoffeeScript 1.9.1
var ExtraMenu, Loader, MenuBuilder, Seq, xhr;
MenuBuilder = require("../menubuilder");
Seq = require("../../model/Sequence");
Loader = require("../../utils/loader");
xhr = require("xhr");
module.exports = ExtraMenu = MenuBuilder.extend({
  initialize: function initialize(data) {
    this.g = data.g;
    this.el.style.display = "inline-block";
    return this.msa = data.msa;
  },
  render: function render() {
    var msa, stats;
    this.setName("Extras");
    stats = this.g.stats;
    msa = this.msa;
    this.addNode("Add consensus seq", function (_this) {
      return function () {
        var con, seq;
        con = stats.consensus();
        seq = new Seq({
          seq: con,
          id: "0c",
          name: "consenus"
        });
        _this.model.add(seq);
        _this.model.setRef(seq);
        _this.model.comparator = function (seq) {
          return !seq.get("ref");
        };
        return _this.model.sort();
      };
    }(this));
    this.addNode("Calc Tree", function () {
      var cbs, newickStr, nwkData;
      newickStr = "";
      cbs = Loader.joinCb(function () {
        return msa.u.tree.showTree(nwkData);
      }, 2, this);
      msa.u.tree.loadTree(cbs);
      nwkData = {
        name: "root",
        children: [{
          name: "c1",
          branch_length: 4,
          children: msa.seqs.filter(function (f, i) {
            return i % 2 === 0;
          })
        }, {
          name: "c2",
          children: msa.seqs.filter(function (f, i) {
            return i % 2 === 1;
          }),
          branch_length: 4
        }]
      };
      msa.seqs.each(function (s) {
        return s.set("branch_length", 2);
      });
      return cbs();
    });
    this.addNode("Increase font size", function (_this) {
      return function () {
        var columnWidth, nColumnWidth, nFontSize;
        columnWidth = _this.g.zoomer.get("columnWidth");
        nColumnWidth = columnWidth + 5;
        _this.g.zoomer.set("columnWidth", nColumnWidth);
        _this.g.zoomer.set("rowHeight", nColumnWidth);
        nFontSize = nColumnWidth * 0.7;
        _this.g.zoomer.set("residueFont", nFontSize);
        return _this.g.zoomer.set("labelFontSize", nFontSize);
      };
    }(this));
    this.addNode("Decrease font size", function (_this) {
      return function () {
        var columnWidth, nColumnWidth, nFontSize;
        columnWidth = _this.g.zoomer.get("columnWidth");
        nColumnWidth = columnWidth - 2;
        _this.g.zoomer.set("columnWidth", nColumnWidth);
        _this.g.zoomer.set("rowHeight", nColumnWidth);
        nFontSize = nColumnWidth * 0.6;
        _this.g.zoomer.set("residueFont", nFontSize);
        _this.g.zoomer.set("labelFontSize", nFontSize);
        if (_this.g.zoomer.get("columnWidth") < 8) {
          return _this.g.zoomer.set("textVisible", false);
        }
      };
    }(this));
    this.addNode("Minimized width", function (_this) {
      return function () {
        return _this.g.zoomer.set("alignmentWidth", 600);
      };
    }(this));
    this.addNode("Minimized height", function (_this) {
      return function () {
        return _this.g.zoomer.set("alignmentHeight", 120);
      };
    }(this));
    this.addNode("Jump to a column", function (_this) {
      return function () {
        var offset;
        offset = prompt("Column", "20");
        if (offset < 0 || offset > _this.model.getMaxLength() || isNaN(offset)) {
          alert("invalid column");
          return;
        }
        return _this.g.zoomer.setLeftOffset(offset);
      };
    }(this));
    this.el.appendChild(this.buildDOM());
    return this;
  }
});